"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionSchema = void 0;
exports.AccordionSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/accordion.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Accordion",
    "description": "Expandable and collapsable text used for diverse editorial purposes e.g. FAQ",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:accordion"
            ]
        },
        "title": {
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "blocks": {
            "type": "array",
            "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                    "title": {
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    },
                    "contents": {
                        "$ref": "https://www.redbull.com/schemas/attributes/paragraph-container.schema.json"
                    }
                },
                "required": [
                    "title",
                    "contents"
                ]
            }
        }
    },
    "required": [
        "type",
        "blocks"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3JkaW9uLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvYWNjb3JkaW9uLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGVBQWUsR0FBRztJQUM3QixLQUFLLEVBQUUsa0VBQWtFO0lBQ3pFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFdBQVc7SUFDcEIsYUFBYSxFQUFFLDhFQUE4RTtJQUM3RixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixzQkFBc0I7YUFDdkI7U0FDRjtRQUNELE9BQU8sRUFBRTtZQUNQLE1BQU0sRUFBRSw2REFBNkQ7U0FDdEU7UUFDRCxRQUFRLEVBQUU7WUFDUixNQUFNLEVBQUUsT0FBTztZQUNmLE9BQU8sRUFBRTtnQkFDUCxNQUFNLEVBQUUsUUFBUTtnQkFDaEIsc0JBQXNCLEVBQUUsS0FBSztnQkFDN0IsWUFBWSxFQUFFO29CQUNaLE9BQU8sRUFBRTt3QkFDUCxNQUFNLEVBQUUsbUZBQW1GO3FCQUM1RjtvQkFDRCxVQUFVLEVBQUU7d0JBQ1YsTUFBTSxFQUFFLDRFQUE0RTtxQkFDckY7aUJBQ0Y7Z0JBQ0QsVUFBVSxFQUFFO29CQUNWLE9BQU87b0JBQ1AsVUFBVTtpQkFDWDthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixRQUFRO0tBQ1Q7Q0FDRixDQUFBIn0=